/**
 * @generated SignedSource<<942e173f25a0f548ee9a53944332c1de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerpsPoolBalanceReinvestSubscription$variables = {
  id: string;
};
export type PerpsPoolBalanceReinvestSubscription$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"PerpsPoolBalanceReinvestFragment">;
  } | null | undefined;
};
export type PerpsPoolBalanceReinvestSubscription = {
  response: PerpsPoolBalanceReinvestSubscription$data;
  variables: PerpsPoolBalanceReinvestSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PerpsPoolBalanceReinvestSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PerpsPoolBalanceReinvestFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PerpsPoolBalanceReinvestSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Balance",
                "kind": "LinkedField",
                "name": "availableYieldLp",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Balance",
                "kind": "LinkedField",
                "name": "availableYieldXlp",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              }
            ],
            "type": "PerpsAccount",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6e4f2c23bf2c6505e3dc4559a709dcff",
    "id": null,
    "metadata": {},
    "name": "PerpsPoolBalanceReinvestSubscription",
    "operationKind": "subscription",
    "text": "subscription PerpsPoolBalanceReinvestSubscription(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...PerpsPoolBalanceReinvestFragment\n    id\n  }\n}\n\nfragment PerpsPoolBalanceReinvestFragment on PerpsAccount {\n  id\n  availableYieldLp {\n    amount\n  }\n  availableYieldXlp {\n    amount\n  }\n}\n"
  }
};
})();

(node as any).hash = "e90bfe6ba8ff99bcece4e20a4f0d6ce6";

export default node;
